import * as React from 'react';

import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Filter() {
    return (
        <OnboardingBody title='Filtering out the noise'>
            <p>As a business owner, you know your industry best.</p>
            <p>
                Nutshell provides tools to exclude industries from your reporting data by filtering
                out any industries you do not want to track. This feature is particularly useful if
                you receive spam from a specific industry or want to avoid marketing to a particular
                segment.
            </p>
        </OnboardingBody>
    );
}
